document.addEventListener('DOMContentLoaded', function () {
  initCustomBlogPosts();
});

// Re-initialize for Shopify Theme Editor sections
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initCustomBlogPosts(event.target);
  });
}

function initCustomBlogPosts(container = document) {
  const sections = container.querySelectorAll('[data-custom-blog-posts]');
  
  sections.forEach(section => {
    const swatches = section.querySelectorAll('[data-swatch-tag]');
    const cards = section.querySelectorAll('[data-article-card]');
    const noResultsMsg = section.querySelector('[data-no-results]');

    if (!swatches.length || !cards.length) return;

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        const selectedTag = this.getAttribute('data-swatch-tag');

        // Update active swatch state
        swatches.forEach(s => {
          s.classList.remove('cb-swatch--active');
          s.classList.add('cb-swatch--inactive');
          s.setAttribute('aria-selected', 'false');
        });

        this.classList.remove('cb-swatch--inactive');
        this.classList.add('cb-swatch--active');
        this.setAttribute('aria-selected', 'true');

        // Filter cards
        let visibleCount = 0;

        cards.forEach(card => {
          const cardTags = (card.getAttribute('data-tags') || '').split(',').map(t => t.trim().toLowerCase());
          
          if (selectedTag === 'all' || cardTags.includes(selectedTag.toLowerCase())) {
            card.classList.remove('is-hidden');
            visibleCount++;
          } else {
            card.classList.add('is-hidden');
          }
        });

        // Toggle empty state if no articles match selected tag
        if (noResultsMsg) {
          if (visibleCount === 0) {
            noResultsMsg.classList.add('is-visible');
          } else {
            noResultsMsg.classList.remove('is-visible');
          }
        }
      });
    });
  });
}
